<template>
  <b-card-code title="" style="margin-top: 50px">
    <b-button variant="primary" class="mb-2" @click="AddExpense">إضافة مصروف</b-button>

    <!-- table -->
    <vue-good-table
      :key="tableRenderKey"
      :columns="columns"
      :rows="this.expenses"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength
      }"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: companyId -->
        <span v-if="props.column.field === 'price'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.price }}</span>
        </span>
        <span v-else-if="props.column.field === 'isReviewed'" class="text-nowrap">
          <span v-if="!props.row.isReviewed" class="text-nowrap">
            <b-button variant="danger" style="margin-right: 16px"> <feather-icon icon="XIcon" size="16" /> </b-button
          ></span>
          <span v-else class="text-nowrap">
            <button variant="success" style="margin-right: 16px" class="btn btn-success">
              <feather-icon icon="CheckIcon" size="16" /></button
          ></span>
        </span>
        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'" style="">
          <div class="d-flex justify-content-start">
            <ImageModal v-if="props.row.imagePath !== null" :imageUrl="props.row.imagePath"> </ImageModal>
            <AddImageModal v-else :paymentChangeId="props.row.id" :type="'expense'" @render-table="GetExpenses"> </AddImageModal>

            <button v-if="!props.row.isReviewed" style="margin-right: 16px" class="btn btn-primary" @click="EditExpense(props.row.id, props.row)">
              <feather-icon icon="EditIcon" size="12" />
            </button>
          </div>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> عرض الصفحة الأولى </span>

            <b-form-select v-model="pageLength"  :options="['20', '30', '50', '70', '100']" class="mx-1" @change="onPerPageChange" />
            <span class="text-nowrap"> من {{ totalCount }} العناصر </span>
          </div>
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalCount"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              class="mt-1 mb-0"
              @input="handlePageChange"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <template #code>
      {{ codeBasic }}
    </template>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BButton,
  BAvatar,
  BBadge,
  BModal,
  VBModal,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BFormDatepicker
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import { codeBasic } from '../code'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ImageModal from '@/@core/components/ImageModal.vue'
import AddImageModal from '@/@core/components/AddImageModal.vue'
export default {
  components: {
    BCardCode,
    VueGoodTable,
    BButton,
    BModal,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormDatepicker,
    ImageModal,
    AddImageModal
  },

  directives: {
    'b-modal': VBModal,
    Ripple
  },
  created() {
    this.GetExpenses()
  },
  data() {
    return {
      expenses: [],
      pageLength: 20,
      currentPage: 1,
      totalCount: 0, // Total rows/items count from API
      totalPages: 0, // Total pages count from API
      dir: false,
      codeBasic,
      columns: [
        {
          label: 'السعر',
          field: 'price'
        },

        {
          label: 'التاريخ',
          field: 'date'
        },
        {
          label: 'البيان',
          field: 'details'
        },
        {
          label: 'حالة المراجعة',
          field: 'isReviewed'
        },
        {
          label: 'التفاصيل',
          field: 'action',
          width: '27%'
        }
      ],
      searchTerm: '',
      tableRenderKey: 0
    }
  },
  methods: {
    async onPerPageChange(newPerPage) {
      // Update pageLength and refresh data for the current page
      this.pageLength = parseInt(newPerPage, 10)
      await this.GetExpenses()
    },
    async handlePageChange() {
      // Fetch data for the current page
      await this.GetExpenses()
    },
    async GetExpenses() {
      let userId = this.$store.getters.ExtractAcessToken.userId
      const payload = {
        agentId: userId,
        page: this.currentPage,
        pageSize: this.pageLength
      }
      try {
        const response = await this.$store.dispatch('GetAgentExpenses', payload)
        if ((response.status = 200)) {
          this.expenses = response.data.result
          this.tableRenderKey++
          this.totalCount = response.data.totalCountData
          this.totalPages = response.data.pagesCount
        }
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'فشل الاتصال بالسيرفر يرجى المحاولة لاحقا',
            icon: 'TrashIcon',
            variant: 'danger'
          }
        })
      }
    },
    AddExpense() {
      this.$router.push({ name: 'add-expense' })
    },
    EditExpense(id, expense) {
      this.$router.push({
        name: 'add-expense',
        params: { id: id }
      })
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    }
  }
}
</script>

<style lang="scss" scoped></style>
